import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import HeaderSection from './HeaderSection';
import ProofSection from './ProofSection';
import PlansSection from './PlansSection';
import FeatureComparisonSection from './FeatureComparisonSection';
import GetStartedSection from './GetStartedSection';

const PricingPage = () => {
    return (
        <>
            <Header />
            <HeaderSection />
            <ProofSection />
            <PlansSection />
            <FeatureComparisonSection />
            <GetStartedSection />
            <Footer />
        </>
    );
};

export default PricingPage;
